import Link from 'next/link';
import React from 'react';

const EmptyCart = ({cartType}) => {

    return (
      <>
      {
      cartType == 'available'
      ?
      <>
        <div  className="empty-cart">
          <div className="img-cart-empty" >
              <img src="/assets/images/empty-cart.png" alt="" />
          </div>
          <p>Su cesta está vacía</p>
          <Link href="/" className="btn-continue" passHref={true}><a><i className="fa fa-angle-left mr-3 fa-lg"></i>Continuar comprando</a></Link>
        </div>
        <div className="clearfix"></div>
      </>
      :
      <>
      <h4 className="subheading">Guardado para después</h4>
        <div  className="empty-latercart">
        <p>Su cesta está vacía</p>
        </div>
        <div className="clearfix"></div>
      </>
      }

        </>

    )
}

export default EmptyCart;
